// // src/routes/ProtectedRoute.js
// import React from "react";
// import { Navigate } from "react-router-dom";
// import { useAuth } from "../hooks/useAuth";

// const ProtectedRoute = ({ children, allowedRoles = [] }) => {
//   const { isAuthenticated, roles } = useAuth(); 
//   if (
//     allowedRoles.length > 0 &&
//     !allowedRoles.some(role => roles.includes(role))
//   ) {
//     return <Navigate to="/unauthorized" />; // You can make this page
//   }

//   return children;
// };

// export default ProtectedRoute;

import React from "react";
import { Navigate } from "react-router-dom";
import { useSessionAuth } from "../auth/SessionAuthContext";

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const { isAuthenticated, roles } = useSessionAuth();

  const hasAccess = allowedRoles.length === 0 || allowedRoles.some(role => roles?.[role]);

  if (!isAuthenticated || !hasAccess) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default ProtectedRoute;

